import { useState } from 'react'
import { apiFetch, type ApiError } from '../api/client'
import { useAdminState } from '../context/AdminContext'
import './LoginView.css'

type LoginState = 'idle' | 'loading' | 'error'

export function LoginView() {
  const { recheck } = useAdminState()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [state, setState] = useState<LoginState>('idle')
  const [errorMsg, setErrorMsg] = useState('')

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault()
    setState('loading')
    setErrorMsg('')
    try {
      await apiFetch('/auth/login', {
        method: 'POST',
        body: JSON.stringify({ email, password }),
      })
      // Re-run whoami so the bootstrap gate routes to shell or not-authorized.
      recheck()
    } catch (err) {
      setState('error')
      const apiErr = err as ApiError
      if (apiErr.status === 401 || apiErr.status === 422) {
        setErrorMsg('Invalid email or password.')
      } else {
        setErrorMsg('Something went wrong, please try again.')
      }
    }
  }

  return (
    <div className="login-container">
      <div className="login-card">
        <h1 className="login-title">Symone Admin</h1>
        <p className="login-subtitle">Sign in with your platform-admin account</p>
        <form onSubmit={handleSubmit} aria-label="Sign in form" noValidate>
          <div className="field">
            <label htmlFor="email">Email</label>
            <input
              id="email"
              type="email"
              autoComplete="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              disabled={state === 'loading'}
              required
              aria-describedby={state === 'error' ? 'login-error' : undefined}
            />
          </div>
          <div className="field">
            <label htmlFor="password">Password</label>
            <input
              id="password"
              type="password"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              disabled={state === 'loading'}
              required
            />
          </div>
          {state === 'error' && (
            <p id="login-error" role="alert" className="login-error">
              {errorMsg}
            </p>
          )}
          <button
            type="submit"
            className="login-btn"
            disabled={state === 'loading' || !email || !password}
            aria-busy={state === 'loading'}
          >
            {state === 'loading' ? 'Signing in…' : 'Sign in'}
          </button>
        </form>
      </div>
    </div>
  )
}
